import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import "./SceletonCardRecommendation.scss"

const SceletonCardRecommendation = ({ key }) => {

    return (
        <div className='sceleton-card-recommendation' key={key}>
            <Stack className='sceleton-card-recommendation__content'>
                <Skeleton  className='sceleton-card-recommendation__item' variant="rectangular" />
            </Stack>
        </div>
    )
}

export { SceletonCardRecommendation }